import Vue from 'vue'

// Loader
Vue.component('Loader',
  () => import('@/components/CORE/Loader')
)
